import comp from "./AudioPlayer";
export default comp;
